import styled from 'styled-components';
import {Dialog} from "@progress/kendo-react-dialogs";

export const StyledDialog = styled(Dialog)`
.k-window.k-dialog {
  margin:1.5rem;
  border-radius:1.2rem;
  
}
    .k-content p{
        padding: 2rem;
        text-align: center;
        font-size: 2.4rem;
        max-width: 700px;
    }
    .k-actions.k-actions-stretched,
    .k-dialog-buttongroup{
        padding:  2rem;
        justify-content: space-around;
    }
    .k-dialog-buttongroup button,
    .k-actions.k-actions-stretched button {
        min-width: 12rem;
        flex-grow:1;
        max-width:calc(50% - .8rem);
    }
`;
